import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import './ShowMoreButton.css';

function ShowMoreButton({ expanded, hiddenCount, noun, onToggle, className = '' }) {
    const label = expanded
        ? 'Show fewer'
        : `Show ${hiddenCount} more${noun ? ` ${noun}` : ''}`;
    const Icon = expanded ? ChevronUp : ChevronDown;
    return (
        <button
            type="button"
            className={`show-more-button${className ? ` ${className}` : ''}`}
            aria-expanded={expanded}
            onClick={onToggle}
        >
            <Icon size={14} strokeWidth={2} />
            <span>{label}</span>
        </button>
    );
}

export default ShowMoreButton;
